import { Box, Card, styled, Typography, useTheme } from "@mui/material";
import { MoreVert, SearchOutlined } from "@mui/icons-material";
import { useState } from "react";
import { CapHeader } from "../components/Typography";
import { TableDropdown } from "../components/TableActions";
import { LiPopover } from "../components/LiPopover";
import type { Size } from "../../../types";

const SearchBox = styled(Box)<{ size?: Size }>(({ size, theme }) => ({
    display: size && size !== `large` ? `block` : `inline-block`,
    position: `relative`,
    transition: `opacity 500ms ease`,
    float: size && size !== `large` ? `none` : `right`,
    width: size && size !== `large` ? `90%` : `250px`,
    marginTop: -5,
    verticalAlign: `middle`,
    ...(size && size !== `large` ? { margin: `0 auto 24px` } : {}),

    "& input": {
        background: `#f5f5f5`,
        border: `2px solid ${theme.palette.account.accent}`,
        height: `40px`,
        width: `100%`,
        borderRadius: `${size !== `large` ? 30 : 5}px`,
        padding: `0 40px 0 20px`,
        fontSize: `15px`,
        fontFamily: `Lato`,
        paddingTop: 1,
        color: `#333`,
        outline: `none`,
        "&::placeholder": {
            color: `#333`,
        },
    },
}));

interface ShoppingFilter {
    year: string;
    search: string;
    status: string;
}

interface ShoppingTableActionsProps {
    handleChangeFilter: (key: number, value: string) => void;
    filter: ShoppingFilter;
    years: { name: string; value: string }[] | undefined;
    shoppingTableSatuses: { name: string; value: string }[];
    handleStatusFilter: (key: number, value: string) => void;
    size: Size;
    popoverClick?: (e?: React.MouseEvent<HTMLElement>) => void;
    disabled: boolean;
}

const ShoppingTableActions = ({
    handleChangeFilter,
    filter,
    years,
    shoppingTableSatuses,
    handleStatusFilter,
    size,
    popoverClick = () => {},
    disabled,
}: ShoppingTableActionsProps) => {
    const theme = useTheme();
    const [popoverOpen, setPopoverOpen] = useState<Element | null>(null);
    const popClick = (e: React.MouseEvent<HTMLElement>) => {
        popoverClick(e);
        setPopoverOpen(null);
    };
    return (
        <>
            <LiPopover
                anchorEl={popoverOpen}
                onClose={() => setPopoverOpen(null)}
                anchorOrigin={{
                    vertical: `bottom`,
                    horizontal: `left`,
                }}
                open={!!popoverOpen}
            >
                <Typography onClick={popClick} sx={{ p: 2, cursor: `pointer` }}>
                    I&apos;m Missing Cash Back
                </Typography>
            </LiPopover>
            <TableDropdown
                {...{
                    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                        handleChangeFilter(3, e.target.value),
                    currentValue: filter.year,
                    options: years ?? [],
                    size,
                    sx: { width: `120px`, mb: 3, mr: 1, ml: size === `small` ? 3 : `5px` },
                    disabled,
                }}
            />
            <TableDropdown
                {...{
                    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                        handleStatusFilter(4, e.target.value),
                    currentValue: filter.status,
                    options: shoppingTableSatuses,
                    size,
                    sx: { width: `140px`, mb: 3, ml: `5px` },
                    disabled,
                }}
            />
            <SearchBox id="shopping-box" size={size}>
                <input
                    onClick={e => e.stopPropagation()}
                    id="searchbox"
                    placeholder="Search for a Merchant"
                    onChange={e => handleChangeFilter(5, e.target.value)}
                    value={filter.search}
                />
                <SearchOutlined sx={{ position: `absolute`, top: `8px`, right: `10px`, height: 25, width: 25 }} />
            </SearchBox>
            <Card sx={{ borderRadius: `12px 12px 0 0`, px: 3, background: theme.palette.account.background }}>
                <CapHeader size={size} py={3} m={0}>
                    ACTIVITY
                    <MoreVert
                        onClick={e => {
                            setPopoverOpen(e.currentTarget);
                        }}
                        sx={{ verticalAlign: `middle`, float: `right`, cursor: `pointer` }}
                    />
                </CapHeader>
            </Card>
        </>
    );
};
export default ShoppingTableActions;
